<template>
  <tk-container
    :status="status"
    class=""
  >
    <div
      slot="header"
      class="px-15 pt-15 pb-10"
    >
      <global-back />
    </div>
    <div
      class="p-x-15 pb-15"
    >
      <div
        class="custom-html"
        v-html="detail"
      />
    </div>
  </tk-container>
</template>

<script>
export default {
  name: 'article-detail',
  data () {
    return {
      status: 'loading',
      type: this.$route.query.type,
      detail: ''
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    async getDetail () {
      const { data: result } = await this.$tkParse.get(`/settings/${this.type === '0' ? 'userAgreement' : 'privacyPolicy'}`)
      this.detail = result
      this.status = false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  p {
    margin: 15px 0;
    line-height: 1.5;
    outline: none;
    padding: 0;
  }
}
</style>
